import React, { useEffect, useRef } from 'react';
import '../styles/testimonials.css';

const testimonialsData = [
  {
    quote: 'I have been consulting Ishira in KalyanNagar for ADHD. After a detailed discussion, we agreed on the best treatment for me. I think both therapy and medicines are helping me manage my emotions, understand my condition and also help me manage my tasks better. I’m glad I decided to take help. Dr. Rishika took the time to understand every facet of my condition to come up with ways to manage them.',
    author: 'Anonymous patient',
    detail: 'Anxiety treatment · 3 months',
    dark: false,
  },
  {
    quote: 'We reached out to Ishira for addiction counselling for a family member. Dr. Rishika was extremely patient, knowledgeable, and structured a practical recovery path. Grateful for their support.',
    author: 'Anonymous patient',
    detail: 'Depression treatment · 1 months',
    dark: true,
  },
];

const Testimonials = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = sectionRef.current?.querySelectorAll('.fade-up');
    elements?.forEach((el) => observer.observe(el));
    return () => elements?.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <section className="testimonials-section" ref={sectionRef}>
      <div className="container">
        <div className="section-header fade-up">
          <span className="section-tag">Stories</span>
          <h2>Voices of healing</h2>
          <p>Real experiences from those who found their path with us</p>
        </div>

        <div className="testimonials-grid fade-up">
          {testimonialsData.map((item, i) => (
            <div className={`testimonial-card ${item.dark ? 'dark' : ''}`} key={i}>
              <div className="testimonial-stars">★ ★ ★ ★ ★</div>
              <blockquote>"{item.quote}"</blockquote>
              <div className="testimonial-author">{item.author}</div>
              <div className="testimonial-detail">{item.detail}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
